import { enqueueSnackbar } from "notistack";
import { cafeReports } from "../../../../../../../api/cafe";
import useDialog from "../../../../../../../hooks/useDialog";
import { usePubContext } from "../../../../hooks/pub-context";
import {
  PremiumPubInfoReportButton,
  PremiumPubInfoReportWrapper,
} from "./style";

const PremiumPubInfoReport = () => {
  const { data } = usePubContext();
  const { openDialog } = useDialog();

  const handleReport = () => {
    if (!data) return;
    openDialog({
      title: "허위정보 신고",
      type: "prompt",
      text: "펍을 방문했는데 허위로 정보가 기재되어 있거나<br/>잘못 기재된 정보가 있다면 내용을 적어주세요.",
      confirm: true,
      confirmText: "보내기",
      onConfirm: () => {
        const textarea = document.getElementById(
          "prompt-textarea"
        ) as HTMLTextAreaElement;
        const value = textarea.value;

        if (!value) {
          enqueueSnackbar("내용을 입력해주세요.", {
            variant: "error",
          });
          return;
        }

        cafeReports({
          cafeId: data.id,
          info: value,
        })
          .then(() => {
            enqueueSnackbar("허위정보 신고가 완료되었습니다.", {
              variant: "success",
            });
          })
          .catch((e: any) => {
            enqueueSnackbar(e.message, { variant: "error" });
          });
      },
    });
  };

  return (
    <PremiumPubInfoReportWrapper>
      <img src="/image-web/search/Icon/pub_icon.svg" alt="icon" />
      <div className="name">{data?.cafeName}</div>
      <PremiumPubInfoReportButton onClick={handleReport}>
        <img src="/image-web/store/Siren.svg" alt="report" />
        <div className="name">허위 정보 신고</div>
      </PremiumPubInfoReportButton>
    </PremiumPubInfoReportWrapper>
  );
};

export default PremiumPubInfoReport;
